import styled from 'styled-components';

//Note: Apple pay button has a bug in the white outline style when you try to make a large border radius, so
//we have to do the styling manually.
export var ApplePayButton = styled.button.withConfig({
  componentId: "sc-1pccz6k-0"
})(["display:inline-block;background-repeat:no-repeat;background-position:50% 50%;background-size:100% 50%;border-radius:4px;background-image:-webkit-named-image(apple-pay-logo-white);background-color:black;padding:0px;box-sizing:border-box;height:100%;width:100%;max-width:750px;cursor:pointer;border:1px solid black;"]);
export var ApplePayButtonContainer = styled.div.withConfig({
  componentId: "sc-1pccz6k-1"
})(["text-align:center;height:100%;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/ApplePay/styled.js
// module id = 1740
// module chunks = 11